'use strict';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {LinkView} from './LinkView';
import {logger} from '../logger';

export class LinkComponent extends Component {
  static propTypes = {
    to: T.string,
    isActive: T.bool,
    activeStateName: T.string,
    activeClassName: T.string,
    activatedClassName: T.string,
    activatedDuration: T.number,
    navState: T.object.isRequired,
    bindParam: T.any,
  };

  static defaultProps = {
    activatedDuration: 100,
  };

  constructor(props) {
    super(props);

    const activeState = this.props.activeStateName || this.props.to;
    if (activeState && !this.props.navState) {
      logger.warn(`Link provided active state "${activeState}" but is missing prop navState!`);
    }

    this.state = {
      isActivated: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if (isFunction(this.props.onNavTo)) {
      this.props.onNavTo();
    }

    if (isFunction(this.props.onClick)) {
      if (!isUndefined(this.props.bindParam)) {
        this.props.onClick(e, this.props.bindParam);
      } else {
        this.props.onClick(e);
      }
    }

    this.triggerActivated();
  }

  render() {
    return (
      <LinkView
        {...this.props}
        onClick={this.handleClick}
        isActivated={this.state.isActivated}
      />
    );
  }

  triggerActivated() {
    if (!this.state.isActivated) {
      this.setState({isActivated: true});
      this.nextTimeout = setTimeout(() => {
        this.setState({isActivated: false});
        this.nextTimeout = null;
      }, this.props.activatedDuration);
    }
  }

  componentWillUnmount() {
    if (this.nextTimeout) {
      clearTimeout(this.nextTimeout);
      this.nextTimeout = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/app/components/Link/LinkComponent.js